
import { Component, Vue, Watch } from 'vue-property-decorator';
import Drawer from '@/components/drawer/index.vue';
import Notifications from '@/components/notifications/ListNotifications.vue';
import user_module from '@/modules/user/index';

import Topmenu from '@/components/topmenu/index.vue';
import Footer from '@/components/footer/index.vue';
import Iframe from '@/components/iframe/index.vue';
import FastNotification from '@/components/notifications/FastNotification.vue';
import allProducts from '@/modules/user/allProducts';
import ModalAccept from '@/components/modal-accept/index.vue';
import Investingcounterpoint from '@/components/investingcounterpoint/index.vue'; 

var CryptoJS = require("crypto-js");

@Component({
  components: {
    Drawer,
    Notifications,
    Topmenu,
    Footer,
    Iframe,
    FastNotification,
    ModalAccept,
    Investingcounterpoint
  },
})
export default class App extends Vue {
  @Watch('login')
  changeLogin(login: string) {
    if (login) {
      this.init(true);
    } else {
      this.init(false);
    }
  }

  rxFailed: boolean = false;

  drawerMaxWidth: number = 210;
 
  headerTextError: string = 'Products are temporarily unavailable.';
  headerSubtextError: string = 'Dear RiXtrema clients! We are currently experiencing an outage. Work is ongoing and expect the service to start coming back online in a few hours. <br/> If you have any questions, please call  <a class="link-color" href="tel:2125137070">(212) 513-7070</a>. <br/><br/> Sincerely, RiXtrema Team';

  evokedModal: boolean = false
  evokedModalExpire: boolean = false;

  disabledModal: boolean = false;
  headerText: string = 'Disabled cookies';
  headerSubtext: string =
    'Please, enable coookies in your browser settings or continue to use our products in <a class="link-color" href="https://rixtrema.net/techmarket">https://rixtrema.net/techmarket</a>';

  closedDrawer: boolean = true;
  rws: any = null;
  loginAction: boolean = true;
  RDExceptions: string[] = ['/requestdemo_pctpro'];

  showBanner: boolean = false;

  iraexternalredirect: boolean = false;

  get isMobile() {
    return user_module.isMobile;
  }

  get firstIframe() {
    return user_module.firstIframe;
  }

  get requestdemoNoToken() {
    if (this.$route.name === 'crm') {
      const crm = user_module.userProducts.find(
        (product) => product.id === 'crm',
      );

      if (!crm?.bought) {
        return true;
      }
    }

    const { id } = this.$route?.params;

    if (!id) {
      return false;
    }

    if (id === 'requestdemo?rdemoiframe=true&source=proplus&product=CRM') {
      return true;
    }

    const requestPage = id.indexOf('requestdemo') > -1;

    if (!requestPage) {
      return false;
    }

    const userProduct = user_module.userProducts.find(
      (product) => product.id === this.$route.name,
    );
    console.log('userProduct', userProduct);
    if (userProduct) {
      const bought = userProduct.bought;

      return !bought;
    }

    return false;
  }

  get src() {
    return user_module.base + '/techmarket-helper?appstore=true&first=true';
  }

  get routerClass() {
    let routerClass = '';

    if (!this.token || this.iraexternalredirect || this.expired) {
      routerClass += 'logout ';
    }

    if (this.iframe) {
      routerClass += 'with-iframe ';
    }

    if (this.request && this.RDExceptions.indexOf(this.$route.path) === -1) {
      routerClass += 'with-iframe-request ';
    }

    if (this.isMobile) {
      routerClass = 'is-mobile ';
    }

    return routerClass;
  }

  get iframe() {
    return Boolean(
      allProducts.find((product: any) => product.id === this.$route.name && !product.onlyLanding),
    );
  }

  get certainPage() {

    return this.$route.fullPath;
  }

  get token() {
    return user_module.token || localStorage.getItem('AppToken');
  }

  get currentRouteFullPath() {
    return this.$route.fullPath;
  }

  get route() {
    return this.$route;
  }

  get noti() {
    return user_module.noti;
  }

  get password() {
    return user_module.password;
  }

  get rawPassword() {
    return user_module.rawPassword;
  }

  get newToken() {
    return user_module.newToken;
  }

  get login() {
    return user_module.login || localStorage.getItem('AppLogin');
  }

  get fingerPrint() {
    return user_module.fingerPrint;
  }

  get request() {
    return user_module.request;
  }

  get userInfo() {
    return user_module.userInfo;
  }

  get expired(){
    return user_module.expired;
  }

  changePassword(){
    
    this.evokedModalExpire = false;
    this.$router.push('/usermenu?id=change');
    
  }

  resolveEvokedModal(){

    this.disabledModal = true; 
    this.evokedModal = false;
  }

  closeModalError(){
    this.$router.push('/')
  }

  bannerClose() {
    localStorage.setItem('AppLastClose', String(new Date().getTime()));
    this.showBanner = false;
  }

  bannerCloseForever() {
    this.showBanner = false;
    localStorage.setItem('AppNotShowBanner12', 'true');
  }

  bannerNotShowAgain() {
    this.showBanner = false;
    localStorage.setItem('AppNotShowBanner12', 'true');
  }

  scrollup() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  changeMobile() {
    user_module.changeMobile(window.innerWidth <= 650);
  }

  checkLoginFromExternal() {
    const query = { ...this.$route.query };
    const tokenFromExternal = query.tokenFromExternal;

    console.log('Login-Token fromEXT', tokenFromExternal);

    if (!tokenFromExternal) return false;

    localStorage.setItem('AppToken', tokenFromExternal.toString());

    delete query.tokenFromExternal;
    this.$router.replace({ query })

    return true;
  }

  init(boo: boolean) {

    this.loginAction = boo;
    this.evokedModalExpire = this.expired;
    user_module.setFirstIframe(true);

  }

  receiveMessage(message: any) {
    if (message.data?.created) {
      const firstIframe: any = this.$refs.firstIframe;

      let encryptedToken = '"' + this.newToken + '"';
      encryptedToken = CryptoJS.AES.encrypt(encryptedToken, 'defaultCryptoKey');
      encryptedToken = encryptedToken.toString();

      let encryptedLogin = '"' + this.login + '"';
      encryptedLogin = CryptoJS.AES.encrypt(encryptedLogin, 'defaultCryptoKey');
      encryptedLogin = encryptedLogin.toString();

      if (firstIframe) {
        let messageForPost: any = {
          token: this.newToken,
          login: this.login,
          encryptedToken: encryptedToken,
          encryptedLogin: encryptedLogin,
          fingerPrint: this.fingerPrint,
          password: this.password,
          rawPassword: this.rawPassword,
          appstore: true,
          userInfo: this.userInfo,
        };

        if (!this.loginAction) {
          messageForPost = {
            appstore: true,
            logout: true,
          };
        }

        firstIframe.contentWindow.postMessage(messageForPost, '*');
      }
    }

    if (message.data?.hideFirst) {
      user_module.setFirstIframe(false);
    }

    // if (message.data.to && message.data.defaultLink){
    //   user_module.changeDefaultLink({id: message.data.to, link: message.data.defaultLink});
    // }

    if (message.data.redirect) {
      this.$router.push(message.data.redirect);
    }

    if (message.data.error) {
      if (message.data.error === 'cookies' && !this.disabledModal) {
        this.evokedModal = true;
      }
    }
  }

  beforeMount() {
    const { href } = location;

    console.log('beforeMount', href, /(&|\?logout=true)/.test(href));

    if (/(&|\?)logout=true/.test(href)) {
      user_module.logout();
    }

    if (
      href.indexOf('test.rixtrema.') > -1 ||
      href.indexOf('rixtrema.') > -1 ||
      href.indexOf('market.rixtrema.net') > -1
    ) {
      user_module.setBase('https://rixtrema.net');
    }

    const currentSites = user_module.currentSites.map((currentSite) => {
      const updatedSite = { ...currentSite };

      const { site, id } = currentSite;

      const page = sessionStorage.getItem('page_' + site);

      if (page && id !== this.$route.name) {
        const link = '/' + site + '/' + page;

        updatedSite.link = link;
        // updatedSite.defaultLink = link;
      } else if (id === this.$route.name) {
        updatedSite.link = this.$route.fullPath;
        // updatedSite.defaultLink = this.$route.fullPath;
      }

      return updatedSite;
    }).filter(s => s);

    console.log('currentSites', currentSites);

    user_module.setCurrentSites(currentSites);

    this.checkLoginFromExternal();
  }

  async mounted() {
    

    const five = 1000 * 60 * 60 * 24 * 5;

    const time = localStorage.getItem('AppLastClose') || 0;

    const limit = five - (new Date().getTime() - Number(time));

    console.log('limit', limit);

    // setTimeout(() => {

    //   const exclusions = [
    //     'marshall.roy@raymondjames.com', 'aaron.schueller@orgelwealth.com', 
    //     'dhansen@401klogic.net', 'duke.porter@ml.com', 'glee@rixtrema.com', 
    //     'lgerman@rixtrema.com', 'bryon.wilhite@empower.com',
    //     'ddebreceni', 'dave.debreceni@edwardjones.com'
        
    //   ];

    //   if (limit <= 0 && !localStorage.getItem('AppNotShowBanner12') && this.$route.name !== 'investingcounterpoint' && exclusions.indexOf(this.login.toLocaleLowerCase()) === -1){
    //     this.showBanner = true;
    //   }

    // }, 20000)

    window.addEventListener('resize', this.changeMobile);
    window.addEventListener('message', this.receiveMessage);

    this.changeMobile();

    // const decoded = atob(this.token);
    
    if (this.token) {

      let success = await user_module.getLogin({ Token: this.token });      

      console.log('success', success);

      if (success) {
        if (success.error) {
          this.$toasted.error(`<b>${success.error}</b>`);
        } else {
          this.init(true);
        }
      } else {
        const success2 = await user_module.getLogin({
          login: this.login,
          Token: this.token,
          disableFinger: true,
        });

        if (success2) {
          const success3 = await user_module.getLogin({
            login: this.login,
            password: success2.Password,
          });

          if (success3) {
            this.init(true);
          } else {
            user_module.logout();
            console.log('not init 3');
          }
        } else {
          user_module.logout();
          console.log('not init 2');
        }
      }
    }

    (() => {
      console.log('windowWidth', window.innerWidth);

      if (window.innerWidth > 650) {
        const s1 = document.createElement('script');
        const s0: any = document.getElementsByTagName('script')[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/5d49cef27d27204601c99db5/default';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
      }
    })();
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
    window.removeEventListener('resize', this.changeMobile);
  }

  created() {
    const externalredirect = this.$route.query.externalredirect;
    this.iraexternalredirect = externalredirect === 'ira';
  }
}
